// authContext.instance.ts
import { createContext } from "react";
import type { AuthContextValue } from "./authContext.types";

const AuthContext = createContext<AuthContextValue | undefined>(undefined);
export default AuthContext;
